// export const WORK_ORDER_TYPE_OPTIONS = {
//     blank: {
//         name: "Blank",
//         slug: "blank"
//     },
//     paint: {
//         name: "Paint",
//         slug: "paint"
//     },
//     electrical: {
//         name: "Electrical",
//         slug: "electrical"
//     },
//     mudAndTape: {
//         name: "Mud & Tape",
//         slug: "mud-and-tape"
//     },
//     drywallInstall: {
//         name: "Drywall Install",
//         slug: "drywall-install"
//     },
//     insulationInstall: {
//         name: "Insulation Install",
//         slug: "insulation-install"
//     },
//     cabinetInstall: {
//         name: "Cabinet Install",
//         slug: "cabinet-install"
//     },
//     flooring: {
//         name: "Flooring",
//         slug: "flooring"
//     },
//     counterTopInstall: {
//         name: "Counter Top Install",
//         slug: "counter-top-install"
//     },
//     roughCarpentry: {
//         name: "Rough Carpentry",
//         slug: "rough-carpentry"
//     },
// } as const

export const WORK_ORDER_TYPE_OPTIONS = {
    blank: {
        name: "Blank",
        slug: "blank",
    },
    treeWork: {
        name: "Tree Work",
        slug: "tree-work",
    },
    tarpRoof: {
        name: "Tarp Roof",
        slug: "tarp-roof",
    },
    muckAndGutInterior: {
        name: "Muck & Gut Interior",
        slug: "muck-and-gut-interior",
    },
    moldRemediation: {
        name: "Mold Remediation",
        slug: "mold-remediation",
    },
    rebuildPrep: {
        name: "Rebuild Prep",
        slug: "rebuild-prep",
    },
    plumbingFixtures: {
        name: "Plumbing Fixtures",
        slug: "plumbing-fixtures",
    },
    electricalFixtures: {
        name: "Electrical Fixtures",
        slug: "electrical-fixtures",
    },
    mudAndTape: {
        name: "Mud & Tape",
        slug: "mud-and-tape",
    },
    drywallHanging: {
        name: "Drywall Hanging",
        slug: "drywall-hanging",
    },
    insulation: {
        name: "Insulation",
        slug: "insulation",
    },
    interiorPaint: {
        name: "Interior Paint",
        slug: "interior-paint",
    },
    installCabinets: {
        name: "Install Cabinets",
        slug: "install-cabinets",
    },
    flooringInstall: {
        name: "Flooring Install",
        slug: "flooring-install",
    },
    doorsAndTrim: {
        name: "Trim Install",
        slug: "trim-install"
    },
    roughCarpentry: {
        name: "Rough Carpentry",
        slug: "rough-carpentry",
    },
    assessNeeds: {
        name: "Assess Needs",
        slug: "assess-needs",
    },
    mAndGCrawlSpace: {
        name: "M & G Crawl Space",
        slug: "m-and-g-crawl-space",
    },
    heavyEquipmentDemo: {
        name: "Heavy Equipment/Demo",
        slug: "heavy-equipment-demo",
    },
    insulateCrawlSpace: {
        name: "Insulate Crawl Space",
        slug: "insulate-crawl-space",
    },
    installRoofing: {
        name: "Install Roofing",
        slug: "install-roofing",
    },
    repairDriveway: {
        name: "Repair Driveway",
        slug: "repair-driveway",
    },
    exteriorDebrisRemoval: {
        name: "Exterior Debris Removal",
        slug: "exterior-debris-removal",
    },
    misc: {
        name: "Misc",
        slug: "misc",
    },
    alternativeMinistry: {
        name: "Alternative Ministry",
        slug: "alternative-ministry",
    },
    roughMechanical: {
        name: "Rough Mechanical",
        slug: "rough-mechanical",
    },
    roughElectrical: {
        name: "Rough Electrical",
        slug: "rough-electrical",
    },
    roughPlumbing: {
        name: "Rough Plumbing",
        slug: "rough-plumbing",
    },
    bathroomRebuild: {
        name: "Bathroom Rebuild",
        slug: "bathroom-rebuild",
    },
    hvacFinal: {
        name: "HVAC Final",
        slug: "hvac-final",
    },
    installCounters: {
        name: "Install Counters",
        slug: "install-counters",
    },
    installAppliances: {
        name: "Install Appliances",
        slug: "install-appliances",
    },
    installInteriorDoors: {
        name: "Install Interior Doors",
        slug: "install-interior-doors",
    },
    installExteriorDoors: {
        name: "Install Exterior Doors",
        slug: "install-exterior-doors",
    },
} as const

export const WORK_ORDER_TYPE_OPTIONS_LIST = Object.entries(
    WORK_ORDER_TYPE_OPTIONS
).map((workOrder) => ({
    value: workOrder[1].slug,
    label: workOrder[1].name,
}))
